/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import axios from 'axios';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import { convertBase64ToImage } from '../../utils/image';
import { securityWaitingMessage } from '../../utils/securityWaitingMessage';
import {
  newCheckInAction,
  newNextAction,
  randomNextAction,
  NEW_NEXT,
  NEW_CHECKIN,
  RANDOM_NEXT,
  uploadImageToPreSignedUrlAction,
} from '../../actions/navigation';

import IDScan from '../../components/IDScan';
import ContentWrapper from '../../components/ContentWrapper';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Footer from '../../components/Footer';
import Pagination from '../../components/Pagination';
import Tooltip from '../../components/Tooltip';
import Validator from '../../components/Validator';
import ApplicationId from '../../components/ApplicationId';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';
import Headline from '../../components/Headline';
import Container from '../../components/Container';
import Transition from '../../components/Transition';
import Header from '../../components/Header';
import Modal from '../../components/Modal';

// Configuration & Assets
import { useConfig } from '../../config/ConfigContext';
import schema from './securitySchema';
import imgError from '../../assets/images/error.svg';
import './style.scss';

let idScanSocket = null;
let timeoutTimer = null;
const NORMAL_CLOSE = 'Normal close';

const LuwaSecurity = (props) => {
  const config = useConfig();
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [isSecurityModalVisible, setIsSecurityModalVisible] = useState(false);
  const [isDisabledVerifyButton, setIsDisabledVerifyButton] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [IDScanData, setIDScanData] = useState(null);
  const [securityWaitingMessageStep, setSecurityWaitingMessageStep] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [idScanUploadFallback, setIdScanUploadFallback] = useState(false);
  const [ipAddress, setIpAddress] = useState('');
  const { checkinData, fetch: { isDone, isRunning }, navigate, location } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  const getBlackbox = () => {
    if (!window.IGLOO || typeof window.IGLOO.getBlackbox !== 'function') {
      console.log('❌ IGLOO not ready — run a collect first');
      return;
    }
    const result = window.IGLOO.getBlackbox();
    // console.log('result.blackbox:', result.blackbox);
    return result.blackbox || '';
  };

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
      });
    } else {
      setFirstName(get(checkinData, 'data.data.firstName'));
    }

    if (document && document.body && !document.getElementById('ioBlackBox')) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.id = 'ioBlackBox';
      hidden.name = 'ioBlackBox';
      document.body.appendChild(hidden);
    }

    window.io_global_object_name = 'IGLOO';
    window.IGLOO = {
      loader: {
        uri_hook: '/iojs/',
        version: 'general5',
        subkey: '',
      },
    };
    const url = '/assets/js/iovation_loader_only.js';

    const script = document.createElement('script');
    script.async = true;
    script.src = url;

    document.head.appendChild(script);

    if (workflowType === 'dtm-luwa' || workflowType === 'ida') {
      axios.get('https://api.ipify.org?format=json&callback=?').then((res) => {
        if (res && res.data) {
          setIpAddress(res.data.ip);
        } else {
          setIpAddress('static ip');
        }
      }).catch(() => {
        setIpAddress('static ip');
      });
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (!get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))) {
      if ((isDone[NEW_NEXT] && !isRunning[NEW_NEXT])) {
        if (get(checkinData, ['data', 'data', 'message', 'text']) || checkinData.isReady) {
          if (get(checkinData, ['data', 'data', 'message', 'text'])) {
            setErrorMessage(get(checkinData, ['data', 'data', 'message', 'text']));
            setIsProgressVisible(false);
          }
        }

        if (get(checkinData, 'data.data.nextAction.path', null)) {
          props.randomNextAction({
            workflowType,
            key: params.key,
            rawUrl: get(checkinData, 'data.data.nextAction.path'),
            data: {},
          });
        } else if (get(checkinData, 'data.url')) {
          let routeUrl = get(checkinData, 'data.url').replace(config.hostUrl, '');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl);
          }
          navigate(routeUrl);
        }
      }

      if ((isDone[NEW_CHECKIN] && !isRunning[NEW_CHECKIN])) {
        let routeUrl = get(checkinData, 'data.url');
        if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
          routeUrl = addLusaHeaderParam(routeUrl);
        }
        navigate(routeUrl);
      }

      if (isDone[RANDOM_NEXT] && !isRunning[RANDOM_NEXT]) {
        let routeUrl = (get(checkinData, 'data.url')
          || get(checkinData, 'state.url')).replace(config.hostUrl, '');
        if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
          routeUrl = addLusaHeaderParam(routeUrl);
        }
        navigate(routeUrl);
      }
    }
  }, [checkinData]);

  const handleIDScanSubmit = (data) => {
    setIDScanData(data.IDScanData);
    setIsDisabledVerifyButton(data.isDisabledVerifyButton);
    setIsSecurityModalVisible(true);
  };

  const handleSubmitFrom = (e) => {
    e.preventDefault();
    setIsSecurityModalVisible(true);
  };

  const lengthInUtf8Bytes = (str) => {
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    const m = encodeURIComponent(str).match(/%[89ABab]/g);
    return str.length + (m ? m.length : 0);
  };

  const handleFail = (err) => {
    idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
    idScanSocket = null;
    timeoutTimer && clearTimeout(timeoutTimer);
    setErrorMessage(err.message || 'An unexpected error occurred, please try again');
    setIsProgressVisible(false);
    // Enable manual upload fallback for front/back on submission failure
    setIdScanUploadFallback(true);
  };

  const finishedProcess = async () => {
    const params = parseUrlParams(window.location.search);
    const iovationBlackBox = await getBlackbox();
    props.newNextAction({
      workflowType,
      key: params.key,
      data: {
        identityVerified: true,
        iovationBlackBox: iovationBlackBox || '',
        ...((workflowType === 'dtm-luwa' || workflowType === 'ida') && { IpAddress: ipAddress || '' }),
      },
      fail: handleFail,
    });
  };

  const endVerificationProcess = () => {
    const params = parseUrlParams(window.location.search);
    idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
    idScanSocket = null;
    props.newCheckInAction({
      workflowType,
      key: params.key,
      data: { identityStatus: true },
      success: (res) => {
        const isProcessing = !get(res, ['data', 'data', 'isReady']);
        if (!isProcessing) {
          finishedProcess();
        } else {
          handleFail({
            message: 'An unexpected error occurred, please try again',
          });
        }
      },
      fail: (e) => {
        idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
        idScanSocket = null;
        timeoutTimer && clearTimeout(timeoutTimer);
        handleFail(e);
      },
    });
  };

  const listenVerificationRes = () => {
    const params = parseUrlParams(window.location.search);

    const applicationId = get(checkinData, 'attributes.entityId');
    idScanSocket = new WebSocket(`${config.idScanWebsocketUrl}?application_id=${applicationId}`);
    console.log('connection:', idScanSocket);
    idScanSocket.addEventListener('message', (event) => {
      console.log('eventData:', event.data);
      const eventData = JSON.parse(get(event, 'data'));
      const eventType = get(eventData, 'EventType');
      if (eventType === 'IDSCAN') {
        props.newCheckInAction({
          workflowType,
          key: params.key,
          data: { identityStatus: true },
          success: (res) => {
            const isProcessing = !get(res, ['data', 'data', 'isReady']);
            if (!isProcessing) {
              idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
              idScanSocket = null;
              timeoutTimer && clearTimeout(timeoutTimer);

              finishedProcess();
            }
          },
          fail: (e) => {
            idScanSocket && idScanSocket.close(1000, NORMAL_CLOSE);
            idScanSocket = null;
            timeoutTimer && clearTimeout(timeoutTimer);
            handleFail(e);
          },
        });
      }
    });

    idScanSocket.addEventListener('close', (event) => {
      if (get(event, 'reason') !== NORMAL_CLOSE || get(event, 'code') !== 1000) {
        console.log('Closed and Reconnecting:', event);
        listenVerificationRes();
      }
    });
  };

  const callNextWorkflow = () => {
    const {
      checkinData: {
        data: {
          data: {
            frontImagePreSignedUrl,
            backOrSecondImagePreSignedUrl,
            selfieImagePreSignedUrl,
          },
        },
      },
    } = props;

    const params = parseUrlParams(window.location.search);
    const formData = {
      ...IDScanData,
      countryCode: 'USA',
      verifyFace: true,
    };

    const frontImgSize = atob(formData.frontImageBase64).length;
    const backImgSize = atob(formData.backOrSecondImageBase64).length;
    const selfieImgSize = atob(formData.faceImageBase64).length;
    console.log('Front Image size = ', frontImgSize);
    console.log('Back Image size = ', backImgSize);
    console.log('Selfi Image size = ', selfieImgSize);
    console.log('total size = ', frontImgSize + backImgSize + selfieImgSize);

    if (params.test) {
      formData.test = params.test;
    }
    setIsProgressVisible(true);
    setSecurityWaitingMessageStep(0);

    setInterval(() => {
      setSecurityWaitingMessageStep(1 % 7);
    }, 15000);

    console.log('IDScan Request: payload size = ', lengthInUtf8Bytes(JSON.stringify(formData)));

    convertBase64ToImage(`data:image/png;base64,${formData.frontImageBase64}`, (blob1) => {
      const frontFile = new File([blob1], 'front-image', { type: 'image/png' });
      props.uploadImageToPreSignedUrlAction({
        data: {
          url: frontImagePreSignedUrl,
          imageData: frontFile,
        },
        success: () => {
          convertBase64ToImage(`data:image/png;base64,${formData.backOrSecondImageBase64}`, (blob2) => {
            const backFile = new File([blob2], 'back-image', { type: 'image/png' });
            props.uploadImageToPreSignedUrlAction({
              data: {
                url: backOrSecondImagePreSignedUrl,
                imageData: backFile,
              },
              success: () => {
                convertBase64ToImage(`data:image/png;base64,${formData.faceImageBase64}`, (blob3) => {
                  const faceFile = new File([blob3], 'face-image', { type: 'image/png' });
                  props.uploadImageToPreSignedUrlAction({
                    data: {
                      url: selfieImagePreSignedUrl,
                      imageData: faceFile,
                    },
                    success: () => {
                      props.newNextAction({
                        workflowType,
                        key: params.key,
                        data: {
                          frontImagePreSignedUrl,
                          backOrSecondImagePreSignedUrl,
                          selfieImagePreSignedUrl,
                          countryCode: 'USA',
                          verifyFace: true,
                          documentType: formData.documentType,
                          trackString: formData.trackString || null,
                          captureMethod: formData.captureMethod,
                        },
                        success: (res) => {
                          const isProcessing = !get(res, ['state', 'data', 'isReady']);
                          const message = get(res, ['state', 'data', 'message', 'text']);
                          if (!isProcessing || message) {
                            !isProcessing && setIsProgressVisible(false);
                            if (message) {
                              setErrorMessage(message);
                              setIsProgressVisible(false);
                            }
                          }
                          if (isProcessing) {
                            timeoutTimer = setTimeout(() => {
                              endVerificationProcess();
                            }, config.verificationIntervals);
                            listenVerificationRes();
                          }
                        },
                        fail: handleFail,
                      });
                    },
                    fail: () => handleFail({ message: 'Unfortunately, we were not able to upload your selfie. Please try again.' }),
                  });
                });
              },
              fail: () => handleFail({ message: 'Unfortunately, we were not able to upload the back of your driver’s license. Please try again.' }),
            });
          });
        },
        fail: () => handleFail({ message: 'Unfortunately, we were not able to upload the front of your driver’s license. Please try again.' }),
      });
    });
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    setErrorMessage('');
  };

  const handleClose = (e) => {
    e.preventDefault();
    setIsSecurityModalVisible(false);
  };

  const handleAgreeButtonClick = (e) => {
    e.preventDefault();
    setIsSecurityModalVisible(false);
    callNextWorkflow();
  };

  const reset = () => {
    setIsDisabledVerifyButton(true);
    setIDScanData(null);
  };

  const disableVerifyBtn = () => {
    setIsDisabledVerifyButton(true);
  };

  return (
    <Transition className="transition-item wrapper wrapper-security">
      <Header />
      {get(checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <ContentWrapper>
        <Headline
          header={(
            <>
              <span>A quick ID and selfie check helps protect your account.</span>
              {' '}
              Your info is securely encrypted throughout the process.
              <Tooltip>We adhere to 128-bit SSL protection and strict encryption.</Tooltip>
            </>
          )}
          className="headline-style"
        />
        <Container className="container">
          <IDScan
            handleSubmit={handleIDScanSubmit}
            onReset={reset}
            className={`${
              (
                isSecurityModalVisible
                || !!errorMessage
              ) ? 'hidden-uploader-alert-section ' : ''
            }${
              isProgressVisible ? 'invisible' : 'visible'
            }`}
            onRetakeHook={disableVerifyBtn}
            enableUploadFallback={idScanUploadFallback}
          />
        </Container>
      </ContentWrapper>
      <Footer>
        <FormRow>
          <FormColumn>
            {
              !isProgressVisible
                && (
                <Button
                  className={`btn arrow ${!isDisabledVerifyButton ? 'visibility-hidden' : ''}`}
                  title="Submit"
                  onClick={handleSubmitFrom}
                  isDisabled={isDisabledVerifyButton}
                />
                )
            }
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn>
            <Pagination activeIndex={2} />
          </FormColumn>
        </FormRow>
        {!isDisabledVerifyButton && !isProgressVisible && (
          <div className="id-verify-btn-wrapper">
            <Button
              className="btn arrow id-verify-btn"
              title="Submit"
              onClick={handleSubmitFrom}
            />
          </div>
        )}
        {
          errorMessage
            && (
            <Modal>
              <div className="card-content error-modal security-error">
                <img src={imgError} alt="" />
                <p>{errorMessage}</p>
                <div onClick={handleButtonClick} className="btn btn-red">OK</div>
              </div>
            </Modal>
            )
        }
        {
          isSecurityModalVisible
            && (
            <Modal>
              <div className="card-header">
                <button type="button" aria-label="Close" className="close" onClick={handleClose} />
                <h5>Consent for ID Verification</h5>
              </div>
              <div className="card-content error-modal" style={{ padding: '30px 45px !important' }}>
                <div onClick={handleAgreeButtonClick} className="btn btn-green">I Agree</div>
                <p>
                  By clicking &quot;I Agree&quot; you give LendingUSA permission via your signature to scan your ID and to share your information with
                  {' '}
                  <a href="http://idscan.net/">IDScan.net</a>
                  , a third-party fraud risk company who uses the information you provided to us to verify your identity and to help prevent ID theft and fraud, and with any State&apos;s Department of Transportation or equivalent agency.
                </p>
              </div>
            </Modal>
            )
        }
      </Footer>
      {
        isProgressVisible && <Spinner message={securityWaitingMessage(securityWaitingMessageStep, firstName)} />
      }
    </Transition>
  );
};

LuwaSecurity.propTypes = {
  navigate: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
  uploadImageToPreSignedUrlAction: PropTypes.func.isRequired,
  randomNextAction: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  identity: state.identity,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
  uploadImageToPreSignedUrlAction,
  randomNextAction,
};

export default Validator(schema)(connect(
  mapStateToProps,
  mapDispatchToProps
)(LuwaSecurity));
